export default () => ({
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '9fr 11fr',
    gridColumnGap: '0.5rem',

    marginBottom: '2rem',
});
